const chatbot = {
  start: {
    messages: [
      {
        message: 'Hello! 👋'
      },
      {
        message: 'You are invited to Apostle Connect!.'
      },
      {
        message:
          'Apostle Connect enables you and your organization to become...'
      }
    ],
    options: [
      {
        text: "Let's get started",
        value: 'step1',
        response: 'Happy to be here'
      },
      {
        text: 'How?',
        value: 'step0_how',
        response: 'I want some more information'
      }
    ]
  },
  step1: {
    messages: [
      {
        message: 'To get started, we would like to get some information of you.'
      }
    ],
    options: [
      {
        text: 'Fill in my information',
        value: 'fill-in-form'
      }
    ]
  },
  step0_how: {
    messages: [
      {
        message:
          'You can find more information about Apostle Connect here: <a>dsad</a>'
      }
    ],
    options: [
      {
        text: 'Okay, thank you!',
        value: 'step1',
        response: 'Okay, thank you!'
      }
    ]
  },
  step2: {
    messages: [
      {
        message: `Happy to have you on board <strong><first_name></strong> 😊`
      },
      {
        message: 'At last, we would like to know something about your interests'
      }
    ],
    options: [
      {
        text: 'Proceed',
        value: 'step3',
        response: 'Bring it on'
      }
    ]
  },
  step3: {
    messages: [
      {
        message:
          'Great! I will give you a small list of some themes. Tap on the themes you find interesting. Those themes will be highlighted. Tap again if you do not want them to be highlighted.'
      },
      {
        message:
          '<Label color="green">test</Label><Label>another</Label><Label color="green">another</Label>'
      },
      {
        message: 'If you are done, tap on "Finish"'
      }
    ],
    options: [
      {
        text: 'Finish',
        value: 'step4',
        response: 'I am done'
      }
    ]
  },
  step4: {
    messages: [
      {
        message:
          'Thank you, <strong><first_name></strong>! Have fun while using Apostle Connect! 🎉'
      }
    ],
    options: [
      {
        text: 'Proceed to Apostle Connect',
        value: 'step5',
        response: "Let's start with Apostle Connect"
      }
    ]
  },
  step_accepted: {
    messages: [
      {
        message: 'Oh no, this invitation is already accepted!'
      },
      {
        message:
          'You can try to login at the login screen or you could ask for a password reset!'
      },
      {
        message: 'If all else fails, please contact your Social Master.'
      }
    ],
    options: [
      {
        text: 'Take me to the login screen',
        value: 'to_login',
        response: 'I want to login'
      },
      {
        text: 'Take me to the password reset screen',
        value: 'to_reset',
        response: 'I want to reset my password'
      }
    ]
  },
  change_location: {
    messages: [
      {
        message: "OK, let's go!"
      }
    ]
  }
};
export default chatbot;
